// removed by extract-text-webpack-plugin
module.exports = {"container":"_2UeBF","donation-list":"_2FwaL","action":"_3ftW7","show-more-button-container":"_3B4bB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Supporters/Supporters.scss
// module id = ./src/components/Supporters/Supporters.scss
// module chunks = 5